import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, renderSlot as _renderSlot, createVNode as _createVNode, mergeProps as _mergeProps, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { computed } from "vue";
import { PaginationEllipsis } from "radix-vue";
import { MoreHorizontal } from "lucide-vue-next";
import { cn } from "@/lib/utils";
export default /*@__PURE__*/ _defineComponent({
    __name: 'PaginationEllipsis',
    props: {
        asChild: { type: Boolean },
        as: {},
        class: {}
    },
    setup(__props) {
        const props = __props;
        const delegatedProps = computed(() => {
            const { class: _, ...delegated } = props;
            return delegated;
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(_unref(PaginationEllipsis), _mergeProps(delegatedProps.value, {
                class: _unref(cn)('tw-w-8 tw-h-8 tw-flex tw-items-center tw-justify-center', props.class)
            }), {
                default: _withCtx(() => [
                    _renderSlot(_ctx.$slots, "default", {}, () => [
                        _createVNode(_unref(MoreHorizontal), {
                            size: 18,
                            class: "tw-text-white"
                        })
                    ])
                ]),
                _: 3
            }, 16, ["class"]));
        };
    }
});
